export const SHOW_QUOTE_THRESHOLD = '920px';
export const CHANGE_MARGIN_TRESHOLD = '1100px';
